import { X } from "lucide-react";
import { useEffect } from "react";

export default function NewsArticleModal({ article, onClose }) {
  useEffect(() => {
    if (!article) return undefined;
    const closeOnEscape = (event) => {
      if (event.key === "Escape") onClose();
    };
    window.addEventListener("keydown", closeOnEscape);
    return () => window.removeEventListener("keydown", closeOnEscape);
  }, [article, onClose]);

  if (!article) return null;

  return (
    <div
      aria-labelledby="news-reader-title"
      aria-modal="true"
      className="modal-backdrop news-reader-backdrop"
      data-testid="news-article-reader-modal"
      role="dialog"
    >
      <article className="news-reader-modal" data-testid="news-article-reader-content">
        <button
          aria-label="Close article"
          className="icon-button"
          data-testid="news-article-reader-close-button"
          onClick={onClose}
          title="Close article"
          type="button"
        >
          <X size={20} />
        </button>
        <img alt="" className="news-reader-image" src={article.image_url} />
        <div className="news-reader-copy">
          <span data-testid="news-article-reader-meta">
            {article.category} <i>•</i> {article.date}
          </span>
          <h2 id="news-reader-title">{article.title}</h2>
          <p className="news-reader-summary">{article.summary}</p>
          <p data-testid="news-article-reader-body">{article.content}</p>
        </div>
      </article>
    </div>
  );
}